import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// import { Manager, Target, Popper } from "react-popper";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Hidden from "@material-ui/core/Hidden";
import Popper from "@material-ui/core/Popper";

// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Mail from "@material-ui/icons/Mail";

// core components
import Button from "components/CustomButtons/Button.jsx";

import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";

import connection from "../../connection";
import general from "../../general";

class HeaderLinks extends React.Component {
  state = {
    open: false,
    openProfile: false,
    mensagens: []
  };
  handleClick = () => {
    this.setState({ open: !this.state.open });
  };
  handleClickProfile = () => {
    this.setState({ openProfile: !this.state.openProfile });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleCloseProfile = () => {
    this.setState({ openProfile: false });
  };
  openProfile = () => {
    window.App.hist.push("/perfil/" + window.App.state.user.id);
    this.setState({openProfile: false});
  };
  openSettings = () => {
    window.App.hist.push("/perfil/" + window.App.state.user.id);
    this.setState({openProfile: false});
  };
  performLogout = () => {
    connection.get("logout", null, ()=>{
      this.setState({ openProfile: false });
      general.success("A sua sessão foi terminada", "Sucesso")
      window.App.hist.push("/login");
    });

  };
  openMessage = (mensagem) => {
    window.App.hist.push("/mensagens/" + mensagem.id);
    let mensagens = this.state.mensagens;
    mensagens.splice(mensagens.indexOf(mensagem),1);
    this.setState({
      mensagens: mensagens,
      open: false
    })
  };
  componentDidMount() {
    connection.get("dashboard/notificacoes", null, (data)=>{
      if(data.success) {
        this.setState({
          mensagens: data.mensagens
        })
      }
    })
  }
  render() {
    const { classes } = this.props;
    const { open, openProfile } = this.state;
    const dropdownItem = classNames(
      classes.dropdownItem,
      classes.primaryHover
    );
    const wrapper = classNames({});
    const managerClasses = classNames({
      [classes.managerClasses]: true
    });
    return (
      <div className={wrapper}>
        <div className={managerClasses}>
          <Button
            color="transparent"
            justIcon
            aria-label="Mail"
            aria-owns={open ? "menu-list" : null}
            aria-haspopup="true"
            onClick={this.handleClick}
            className={classes.buttonLink}
            muiClasses={{
              label: ""
            }}
            buttonRef={node => {
              this.anchorEl = node;
            }}
          >
            <Mail
              className={
                classes.headerLinksSvg +
                " " +
                (classes.links)
              }
            />
            {this.state.mensagens.length > 0 ? (<span className={classes.notifications}>{this.state.mensagens.length}</span>) : null}
            <Hidden mdUp implementation="css">
              <span onClick={this.handleClick} className={classes.linkText}>
                {"Notificações"}
              </span>
            </Hidden>
          </Button>
          <Popper
            open={open}
            anchorEl={this.anchorEl}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !open,
              [classes.popperResponsive]: true,
              [classes.popperNav]: true
            })}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list"
                style={{ transformOrigin: "0 0 0" }}
              >
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    {this.state.mensagens.length > 0 ?
                      <MenuList role="menu">
                        {this.state.mensagens.map((mensagem) => {
                          return (<MenuItem
                            onClick={() => {
                              this.openMessage(mensagem)
                            }}
                            className={dropdownItem}
                          >
                            {mensagem.assunto}
                          </MenuItem>)
                        })}
                      </MenuList>
                      : (<span style={{padding:"15px 30px"}}>Sem Mensagens por ler</span>)}
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>

        <div className={managerClasses}>
          <Button
            color="transparent"
            justIcon
            aria-label="Person"
            aria-owns={openProfile ? "menu-list" : null}
            aria-haspopup="true"
            onClick={this.handleClickProfile}
            className={classes.buttonLink}
            muiClasses={{
              label: ""
            }}
          >
            <Person
              className={
                classes.headerLinksSvg +
                " " +
                (classes.links)
              }
            />
            <Hidden mdUp implementation="css">
              <span className={classes.linkText}>
                {general.firstAndLast(window.App.state.user.name)}
              </span>
            </Hidden>
          </Button>
          <span onClick={this.handleClickProfile}
              className={classes.linkText + " " + classes.profileNameLink}
              ref={node => {
                this.anchorElProfile = node;
              }}>
            {general.firstAndLast(window.App.state.user.name)}
          </span>
          <Popper
            open={this.state.openProfile}
            style={{
              display: this.state.openProfile ? undefined : "none"
            }}
            anchorEl={this.anchorElProfile}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !this.state.openProfile,
              [classes.popperResponsive]: true,
              [classes.popperNav]: true
            })}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list"
                style={{ transformOrigin: "0 0 0" }}
              >
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={this.handleCloseProfile}>
                    <MenuList role="menu">
                      <MenuItem
                        onClick={this.openProfile}
                        className={dropdownItem}
                      >
                        {"Perfil"}
                      </MenuItem>
                      <MenuItem
                        onClick={this.performLogout}
                        className={dropdownItem}
                      >
                        {"Logout"}
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(headerLinksStyle)(HeaderLinks);
